
import React from 'react';
import AppRoutes from './Routes/AppRoutes';
import './App.css'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from './Store/store';
import { Provider } from 'react-redux';


import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Provider store={store}>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="premium-toast"
        bodyClassName="premium-toast-body"
      />
      <AppRoutes />
    </Provider>
  );
}

export default App;
